import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Badge } from "react-bootstrap";
import { Card } from "shards-react";
import { EntypoCheck, EntypoClock, EntypoCreditCard, EntypoWallet, EntypoCredit, EntypoKey } from "react-entypo-icons";
import { primaryColor } from "../config/colors";
import { strings } from "../localization";
import { withRouter } from "react-router-dom";
import {
  navigatePage,
  ORG_ID,
  ROUTE_PREFIX,
  TABLE_ID,
  formateNumber,
  clearFoodDataFromStorage,
  getLogoUrl,
  getOrganisationInfo,
} from "../config";
import "./PaymentSuccessEnhanced.css";
import { getPaymentStatus } from "../api/ApiServices";

const PaymentSuccessEnhanced = ({ match, location }) => {
  const { restaurantName } = match.params || {};
  console.log("DEBUG payment success page in restaurantName", restaurantName);

  // Query params
  const queryParams = new URLSearchParams(location.search);
  const referenceId = queryParams.get("referenceId");
  const klapOrderId = queryParams.get("orderId");
  console.log("referenceId in payment success page", referenceId);
  console.log("orderId in payment success page", klapOrderId);

  const [showAnimation, setShowAnimation] = useState(false);
  const [showPulseAnimation, setShowPulseAnimation] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isLoading, setIsLoading] = useState(true);

  const [orderId, setOrderId] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [paymentReferenceId, setPaymentReferenceId] = useState("");
  const [logoImg, setLogoImg] = useState("");
  const [organisationName, setOrganisationName] = useState("")

  console.log('orderId', orderId)
  console.log('totalAmount', totalAmount)
  console.log('paymentMethod', paymentMethod)
  console.log('paymentDate', paymentDate)
  console.log('organisationName', organisationName)

  useEffect(() => {
    // Trigger animation after loading completes
    const animationTimer = setTimeout(() => {
      setShowAnimation(true);
    }, 200);

    const pulseAnimationTimer = setTimeout(() => {
      setShowPulseAnimation(true);
    }, 2100);

    return () => {
      clearTimeout(animationTimer);
      clearTimeout(pulseAnimationTimer);
    };
  }, []);

  const getPaymentData = () => {
    const orgData = getOrganisationInfo()
    getPaymentStatus(referenceId).then(async (res) => {
      if (res.status === 200) {
        const parsedData = await res.json();
        const data = parsedData.data || undefined
        if (data) {
          // Set payment data from API response
          setOrderId(data.orderId || "");
          setTotalAmount(data.amount || "0");
          setPaymentMethod(data.payment_method || "");
          setPaymentDate(parsedData.log.created_at || "");
          // setPaymentReferenceId(parsedData.referenceId || referenceId || "");
          setOrganisationName(orgData.name || "")
        }
        clearFoodDataFromStorage();
        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    // Load logo
    const logoURl = getLogoUrl();
    if (logoURl) {
      setLogoImg(logoURl);
    }

    getPaymentData();
  }, []);

  const handleViewOrder = () => {
    navigatePage(`/${ROUTE_PREFIX}${restaurantName}/current-orders`);
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Loading Component
  if (isLoading) {
    return (
      <Container fluid className="payment-success-enhanced-container">
        <Row className="w-100 h-100">
          <Col
            xs={12}
            sm={12}
            md={8}
            lg={6}
            xl={5}
            className="mx-auto d-flex align-items-center"
          >
            <div className="loading-container">
              <div className="loading-spinner">
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
                <div className="spinner-ring"></div>
              </div>
              <div className="loading-text">
                <h3>{strings.processing_payment}...</h3>
                <p>{strings.please_wait_while_we_confirm_your_order}</p>
              </div>
              <div className="loading-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid className="payment-success-enhanced-container">
      <Row className="w-100 h-100">
        <Col
          xs={12}
          sm={12}
          md={8}
          lg={6}
          xl={5}
          className="mx-auto d-flex align-items-center"
        >
          <Card
            className={`payment-success-enhanced-card ${
              showAnimation ? "animate-in" : ""
            }`}
          >
            {/* Restaurant Logo and Slug Header - Centered */}
            <div className="text-center mb-4">
              {logoImg && (
                <img
                  src={`data:image/png;base64,${getLogoUrl()}`}
                  alt="Logo"
                  height="40"
                />
              )}
              <p className="my-2" style={{ fontSize: '20px', fontWeight: '600' }}>{organisationName}</p>
            </div>
            {/* Success Icon with Animation */}
            <div className="success-icon-container mb-4">
              <div className={`success-icon ${showPulseAnimation ? "pulse" : ""}`}>
                <div className="success-icon-inner">
                  <EntypoCheck className="check-icon" />
                </div>
                <div className="success-ripple"></div>
              </div>
            </div>

            {/* Main Message */}
            <div className="text-center mb-4">
              <h2 className="success-title">{strings.payment_successful}</h2>
              <p className="success-message">{strings.thank_you_for_order}</p>
              <p className="preparation-message">
                {strings.your_food_is_being_prepared}
              </p>
            </div>

            {/* Order Summary Card */}
            <div className="order-summary-card mb-4">
              <h5 className="summary-title">{strings.payment_summary}</h5>

              {/* Order ID */}
              <div className="order-detail-item">
                <span className="detail-label">
                  <EntypoCreditCard className="detail-icon" />
                  {strings.your_order_id}:
                </span>
                <span className="detail-value ps-order-id">{orderId}</span>
              </div>

              {/* Payment Time */}
              <div className="order-detail-item">
                <span className="detail-label">
                  <EntypoClock className="detail-icon" />
                  {strings.payment_time}:
                </span>
                <span className="detail-value">
                  {formatDateTime(paymentDate)}
                </span>
              </div>

              {/* Amount */}
              {totalAmount && (
                <div className="order-detail-item">
                  <span className="detail-label">
                    <EntypoWallet className="detail-icon" />
                    {strings.amount}:
                  </span>
                  <span className="detail-value ps-total-amount">
                    {formateNumber(totalAmount)}
                  </span>
                </div>
              )}

              {/* Payment Reference ID */}
              {paymentReferenceId && (
                <div className="order-detail-item">
                  <span className="detail-label">
                    <EntypoKey className="detail-icon" />
                    {strings.payment_reference_id}:
                  </span>
                  <span className="detail-value payment-reference">
                    {paymentReferenceId}
                  </span>
                </div>
              )}

              {/* Payment Method */}
              {paymentMethod && (
                <div className="order-detail-item">
                  <span className="detail-label">
                    <EntypoCredit className="detail-icon" />
                    {strings.payment_method}:
                  </span>
                  <span className="detail-value payment-method">
                    {paymentMethod}
                  </span>
                </div>
              )}
            </div>

            {/* Order Items Preview */}
            {/* {orderItems && orderItems.length > 0 && (
              <div className="order-items-preview mb-4">
                <h6 className="items-title">Your Order:</h6>
                <div className="items-list">
                  {orderItems.slice(0, 3).map((item, index) => (
                    <div key={index} className="order-item">
                      <span className="item-name">{item.name}</span>
                      <span className="item-quantity">x{item.quantity}</span>
                    </div>
                  ))}
                  {orderItems.length > 3 && (
                    <div className="more-items">
                      +{orderItems.length - 3} more items
                    </div>
                  )}
                </div>
              </div>
            )} */}

            {/* Action Buttons */}
            <div className="action-buttons">
              <button
                variant="primary"
                // className="action-btn view-order-btn w-100"
                className="btn btn-primary btn-block w-100 mt-2"
                onClick={handleViewOrder}
              >
                {strings.go_to_orders}
              </button>
            </div>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default withRouter(PaymentSuccessEnhanced);
